import { api } from '@/api';

export interface ClarifierAnswer {
  answer: string;
}

export interface ClarifierQuestion {
  question: string;
  answers: ClarifierAnswer[];
}

export interface ImprovePromptClarifiersRequest {
  originalPrompt: string;
  chatId: string | null;
}

export interface ImprovePromptClarifiersResponse {
  questions: ClarifierQuestion[];
}

const improvePromptClarifiersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    improvePromptClarifiers: builder.mutation<ImprovePromptClarifiersResponse, ImprovePromptClarifiersRequest>({
      query: ({ originalPrompt, chatId }) => ({
        url: '/chat/v1/improve-prompt/clarifiers',
        method: 'POST',
        body: { originalPrompt, chatId },
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useImprovePromptClarifiersMutation } = improvePromptClarifiersApi;
